import React from "react";
import { GatsbyImage, ImageDataLike, getImage } from "gatsby-plugin-image";
import mediumZoom from "medium-zoom";
import { isDesktop } from "react-device-detect";

export const ZoomableImage = ({
  id,
  image,
  alt,
}: {
  id: string;
  image: ImageDataLike;
  alt: string;
}) => {
  return (
    <GatsbyImage
      id={`zoomable-image-${id}`}
      image={getImage(image)!}
      alt={alt}
      onLoad={() => {
        mediumZoom(`#zoomable-image-${id}`, {
          margin: isDesktop ? 100 : 0,
          background: "rgba(0, 0, 0, .5)",
        });
      }}
    />
  );
};
